<template>
    <div class="returnHome" @click="clickEvent" v-if="isWebChat"><img :src="btnImg" alt=""/></div>
</template>
<script>
import {miniBack} from '@/tools/miniback.js'
export default {
  data(){
    return{
      btnImg:'//static.daojia.com/fe/jz/daojiaapp/hongbao/image/returnHomeImg2.png',
      isWebChat:false
    }
  },
  created(){
    var that = this;
    if (typeof wx == 'object'){
      wx.miniProgram.getEnv(function(res) {
          if (res.miniprogram){   // 小程序环境
              that.isWebChat=true;
          }
      })
    }
  },
  methods:{
    clickEvent(){
      miniBack()
      // wx.miniProgram.navigateTo({url:'/pages/index/index'});
    }
  }
}
</script>
<style>
  .returnHome{
    position: fixed;
    width: 77px;
    height: 27px;
    top: 10px;
    left: 0;
    z-index: 5;
    border-radius: 0 14px 14px 0;
    background: rgba(0,0,0,.45);
  }
  .returnHome:active{
    background: rgba(0,0,0,.5);
  }
</style>


// WEBPACK FOOTER //
// ReturnBtn.vue?40341cb8